(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('.product-media__video');
    videos.forEach(video => {
      video.muted = true;
      video.play().catch(() => {});
    });
  });
  } catch(e) { console.error(e); }
})();

})();
